import { TransformedResponse, Response } from '../serviceUtils'

export interface CTAButtonsResource {
  id: string
  inst_id: string
  loc_id: string
  actionid: string
  status: boolean
  name: string
  url: string
  sortorder: string
  bg_color: string
  font_color: string
  font_color_type: string
}

export interface TransformedCTAButtonsResponse extends TransformedResponse {
  ctaButtons: Array<Partial<CTAButtonsResource>>
}

export const transformCTAButtonsResponse = ({
  isError,
  status,
  errors,
  resources,
}: Response<Array<CTAButtonsResource>>): TransformedCTAButtonsResponse => ({
  isError,
  status,
  errors,
  ctaButtons: resources.data,
})

export const getCTAButtons = ({ instId, locId }) => ({
  url: `institutions/${instId}/locations/${locId}/actionbuttons`,
})

export const getDefaultCTAButtons = ({ instId, locId}) => ({
  url: `institutions/${instId}/locations/${locId}/actionbuttons/_default`,
})